import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validateCIF = (value) => {
    const match = value.match(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/);

    if (match) {
        const matchLetter = match[1];
        const matchNumber = match[2];
        const matchControl = match[3];

        let evenSum = 0;
        let oddSum = 0;
        let n;

        for (let i = 0; i < matchNumber.length; i++) {
            n = parseInt(matchNumber[i], 10);

            // Odd positions (Even index equals to odd position. i=0 equals first position)
            if (i % 2 === 0) {
                // Odd positions are multiplied first.
                n *= 2;

                // If the multiplication is bigger than 10 we need to adjust
                oddSum += n < 10 ? n : n - 9;
            } else {
                // Even positions
                // Just sum them
                evenSum += n;
            }
        }

        const controlDigit = Number(String(10 - Number(String(evenSum + oddSum).substr(-1))).substr(-1));
        const controlLetter = 'JABCDEFGHI'.substr(controlDigit, 1);

        if (matchLetter.match(/[ABEH]/)) {
            // Control must be a digit
            return String(matchControl) === String(controlDigit);
        } else if (matchLetter.match(/[PQRSW]/)) {
            // Control must be a letter
            return String(matchControl) === String(controlLetter);
        } else {
            // Can be either
            return String(matchControl) === String(controlDigit) || String(matchControl) === String(controlLetter);
        }
    }

    return false;
};

export const cif = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (!v) {
            return null;
        }

        v = v.toUpperCase().replace(/\s/, '');

        return validateCIF(v) ? null : { cif: true };
    };
};
